
export const navLinks = [
  { title: 'Accueil', path: '/home' },
  { title: 'Votre Impact', path: '/your-impact' },
  { title: 'Précommande', path: '/game-order' },
  { title: 'L\'équipe', path: '/discover-the-team' },
]
